import { render, staticRenderFns } from "./TipTapImageSelectionModal.vue?vue&type=template&id=ec43c4b0"
import script from "./TipTapImageSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TipTapImageSelectionModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports